import { useEffect, useState } from 'react';
import { navigationRef } from '../NavigationWrapper';
/** Subscribes to the navigation container's active (deepest) route name. */
export default function useActiveRouteName() {
    const [name, setName] = useState(() => navigationRef.isReady() ? navigationRef.getCurrentRoute()?.name : undefined);
    useEffect(() => {
        let raf;
        let unsubscribe;
        const update = () => setName(navigationRef.getCurrentRoute()?.name);
        const attach = () => {
            if (navigationRef.isReady()) {
                update();
                unsubscribe = navigationRef.addListener('state', update);
            }
            else {
                raf = requestAnimationFrame(attach);
            }
        };
        raf = requestAnimationFrame(attach);
        return () => {
            cancelAnimationFrame(raf);
            unsubscribe?.();
        };
    }, []);
    return name;
}
